import { useQuery } from '@tanstack/react-query';
import { getETI } from '../api';
import { ETI } from '../types';

export const getQueryKey = (taskId: number) => {
  return ['eti', taskId];
};

const useETI = (taskId: number, enabled = true) => {
  const { isLoading, data, error } = useQuery({
    queryKey: getQueryKey(taskId),
    queryFn: () => getETI(taskId),
    enabled,
    refetchOnWindowFocus: false,
  });

  return {
    eti: (data?.parsedBody as ETI) ?? null,
    isLoading: enabled ? isLoading : false,
    error: error ?? null,
  };
};

export default useETI;
